import companyLogo from 'assets/funnel/power_serv.jpg';
import aiDisclaimer from 'assets/funnel/ai-disclaimer.png';
import handshakeImg from 'assets/funnel/hand_shake_lkw.png';

// TODO: replace with hermes_915-specific images
import heroImg from 'assets/funnel/hermes_915_hero.jpg';
import infoHeroImg from 'assets/funnel/hermes_915_hero_2.jpg';
import jobDetailsImg from 'assets/funnel/hermes_915_3.jpg';
import groupImg from 'assets/funnel/hermes_915_4.jpg';

const hermes_915 = {
  documentTitle: "Produktionsmitarbeiter (m/w/d) in der chemischen Industrie | POWERSERV Austria GmbH",
  companyLogo,
  companyName: "POWERSERV Austria GmbH",
  aiDisclaimer,

  landing: {
    heroImg,
    chipText: "Vollzeit · €2.777 / Monat · Wolfsberg",
    heroTitle: "Produktionsmitarbeiter (m/w/d) · Pharma & Chemie · Vollzeit",
    heroSubtitle: "Verpackung von Arzneimitteln und Medizinprodukten bei einem führenden Pharmabetrieb in Wolfsberg.",
    facts: [
      { icon: 'bi-cash-stack',   title: '€ 2.777,44 / Monat',     subtitle: 'Brutto-Mindestlohn · Vollzeit' },
      { icon: 'bi-geo-alt-fill', title: 'Wolfsberg',              subtitle: 'Standort' },
      { icon: 'bi-clock',        title: '2–3-Schichtmodell',      subtitle: 'flexibles Schichtmodell' },
      { icon: 'bi-p-square',     title: 'Parkplätze',             subtitle: 'am Firmengelände' },
    ],
  },

  info: {
    heroImg: infoHeroImg,
    heroChip: "Vollzeit · Chemische Industrie",
    heroTitleLines: ["Produktionsmitarbeiter", "(m/w/d)"],
    facts: [
      { value: "€ 2.777", label: "Brutto-Mindestlohn + Überzahlung möglich" },
      { value: "Vollzeit", label: "Wolfsberg" },
    ],
    moechtestDuItems: [
      { icon: 'bi-capsule',             text: 'Arzneimittel, Nahrungsergänzungsmittel und Medizinprodukte verpacken und dabei zum Schutz von Menschen beitragen?' },
      { icon: 'bi-gear-wide-connected', text: 'modernste Verpackungsmaschinen, Kontrollwaagen und Etikettiergeräte bedienen und Produktionsprozesse aktiv überwachen?' },
      { icon: 'bi-graph-up-arrow',      text: 'in einem familiären Betrieb mit internen Weiterbildungsmöglichkeiten langfristig durchstarten – egal ob Berufseinsteiger oder erfahrene Fachkraft?' },
    ],
    benefits: [
      { icon: 'bi-cash-stack',      title: '€ 2.777,44 Mindestlohn',       desc: 'Brutto pro Monat auf Basis Vollzeitbeschäftigung (EUR 16,88 pro Stunde) – Überzahlung je nach Praxis und Qualifikation möglich.' },
      { icon: 'bi-clock',           title: '2–3-Schichtmodell',            desc: 'Flexible Schichteinteilung im 2- bis 3-Schichtbetrieb.' },
      { icon: 'bi-p-square',        title: 'Parkplätze am Firmengelände',  desc: 'Kostenlose Parkplätze direkt am Betriebsgelände.' },
      { icon: 'bi-arrow-up-circle', title: 'Überzahlung möglich',          desc: 'Bei entsprechender Qualifikation oder Berufserfahrung ist eine Überzahlung möglich.' },
      { icon: 'bi-book',            title: 'Interne Weiterbildung',        desc: 'Interne Weiterbildungsmöglichkeiten für deine berufliche Entwicklung.' },
      { icon: 'bi-people',          title: 'Familiäres Arbeitsklima',      desc: 'Ein vielseitiges Aufgabengebiet in einem familiären, wertschätzenden Umfeld.' },
    ],
    aufgabenTitle: "Qualität beginnt in der Produktion.",
    tasks: [
      'Verpackung von Arzneimitteln, Nahrungsergänzungsmitteln und Medizinprodukten',
      'Bedienung von Verpackungsmaschinen, Kontrollwaagen, Etikettier- und Kennzeichnungsgeräten',
      'Reinigung der Produktionslinie gemäß SOPs und geltenden Hygienevorschriften',
      'Überwachung und Kontrolle des Abfüll- und Verpackungsprozesses',
      'Protokollierung und Dokumentation der Arbeitsabläufe',
      'Unterstützung in anderen Abteilungen nach Bedarf',
    ],
    requirements: [
      'Idealerweise bereits Erfahrung in der Produktion',
      'Bereitschaft zur Arbeit im 3-Schichtbetrieb',
      'Vorlage eines einwandfreien polizeilichen Führungszeugnisses',
      'Sicherer Umgang mit dem Computer',
      'Teamfähigkeit und Zuverlässigkeit',
      'Hohe Flexibilität und Einsatzbereitschaft',
      'Gute Deutschkenntnisse um Sicherheits- und Arbeitsanweisungen zu gewährleisten',
    ],
    jobDetailsImg,
    jobDetailsTagLines: ["Pharma &", "Produktion"],
    noteText: "Egal ob du Berufseinsteiger, Student oder schon erfahren bist – bewirb dich schnell und unkompliziert mit nur einem Klick und starte deine berufliche Zukunft bei uns.",
    groupImg,
    companyDescription: "Wir bei POWERSERV Austria stellen Menschen in den Mittelpunkt – Bewerber:innen, Mitarbeiter:innen und Kund:innen. Unser Anspruch ist es, durch Qualität, persönliche Betreuung und Engagement die besten Lösungen in der Personaldienstleistung zu bieten. Als zugelassene Personalvermittlerin setzen wir auf nachhaltiges Wachstum, langjährige Partnerschaften und entwickeln uns laufend im Einklang mit den Markttrends weiter. Unsere Vision: arbeitssuchenden Menschen die passenden Karrieremöglichkeiten eröffnen und Unternehmen mit den richtigen Mitarbeiter:innen zusammenbringen.",
    finalCtaTitle: "Dann bist du bei uns genau richtig!",
    finalCtaText: "Beantworte ein paar kurze Fragen – ganz ohne Lebenslauf und Anschreiben. Wir melden uns bei dir.",
  },

  quiz: {
    handshakeImg,
  },
};

export default hermes_915;
